export class ApplicationStatusResponseDTO {
  status: string;
  statusCode: string;
  statusDescription: string;
  messages: string[];
}
